import { useMemo } from "react";

import Highcharts, { TooltipFormatterContextObject } from "highcharts";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { OptionHistogramData } from "@mapmycustomers/shared/types/map/PinLegend";

import anyColorToHex from "@app/util/colors/anyColorToHex";

const useOptionHistogramChartConfig = (config: {
  data: OptionHistogramData;
  getColor: (value: number | string) => AnyColor;
  visible?: boolean;
}): Highcharts.Options => {
  const { data, getColor, visible } = config;
  return useMemo(() => {
    if (!visible) {
      return {};
    }

    const seriesData = data.map(({ count }) => count);

    return {
      chart: {
        height: 200,
        plotShadow: false,
        spacingBottom: 4,
        spacingLeft: 0,
        spacingRight: 32,
      },
      colors: data.map(({ key }) => anyColorToHex(getColor(key))),
      credits: undefined,
      legend: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          borderColor: "black",
        },
      },
      series: [
        {
          colorByPoint: true,
          data: seriesData,
          name: "",
          type: "bar",
        },
      ],
      title: {
        text: "",
      },
      tooltip: {
        formatter(this: TooltipFormatterContextObject): string {
          return `${this.y}`;
        },
      },
      xAxis: {
        categories: data.map(({ key }) => String(key)),
        lineColor: "black",
        lineWidth: 1,
        minorTicks: false,
        type: "category",
      },
      yAxis: {
        // gridLineWidth: 0,
        // lineColor: "black",
        // lineWidth: 1,
        // max: seriesData
        //   .map(({ y }) => y)
        //   .reduce((result, value) => (value > result ? value : result)),
        // tickWidth: 1,
        // title: {
        //   text: "",
        // },
      },
    };
  }, [data, getColor, visible]);
};

export default useOptionHistogramChartConfig;
